<template>
    <div class="password">
        <LoginHeaderCmp title="找回密码"/>
        <router-view></router-view>
    </div>
</template>
<style>

</style>
<script>
    import LoginHeaderCmp from "./LoginHeaderCmp.vue";
    export default{

        components:{
            LoginHeaderCmp
        }
    }
</script>
